import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import TicketRequest from "../../magData/Bus/TicketRequest";
import TicketResponse from "../../magData/Bus/TicketResponse";

function BusTicketPage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Bus Ticket Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/bus/ticket</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(TicketRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>success</td>
                  <td>success</td>
                  <td>boolean </td>
                  <td>None.</td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>id</td>
                  <td>
                    id
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>ticketNumber</td>
                  <td>ticketNumber</td>
                  <td>String</td>
                  <td><p>None.</p></td>
                </tr>
                <tr>
                  <td>contact</td>
                  <td>contact</td>
                  <td>Collection of String</td>
                  <td><p>None.</p></td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>name</td>
                          <td>
                            name
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>mobilePhone</td>
                          <td>
                            mobilePhone
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>busId</td>
                  <td>
                    busId
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>company</td>
                  <td>
                    company
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>operatingCompany</td>
                  <td>
                    operatingCompany
                  </td>
                  <td>String</td>
                  <td>
                    <p>Collection of String</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>code</td>
                          <td>
                            code
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>name</td>
                          <td>
                            name
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>boardingPoint</td>
                  <td>
                    boardingPoint
                  </td>
                  <td>Collection of String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>city</td>
                          <td>
                            city
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>terminal</td>
                          <td>
                            terminal
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>additionalInfo</td>
                          <td>
                            additionalInfo
                          </td>
                          <td>Collection of String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>city</td>
                                  <td>
                                    city
                                  </td>
                                  <td>Collection of String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>id</td>
                                          <td>
                                            id
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>name</td>
                                          <td>
                                            name
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>englishName</td>
                                          <td>
                                            englishName
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                                <tr>
                                  <td>name</td>
                                  <td>
                                    name
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>englishName</td>
                                  <td>
                                    englishName
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>droppingPoints</td>
                  <td>
                    droppingPoints
                  </td>
                  <td>Collection of String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>city</td>
                          <td>
                            city
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>terminal</td>
                          <td>
                            terminal
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>additionalInfo</td>
                          <td>
                            additionalInfo
                          </td>
                          <td>Collection of String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>city</td>
                                  <td>
                                    city
                                  </td>
                                  <td>Collection of String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>id</td>
                                          <td>
                                            id
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>name</td>
                                          <td>
                                            name
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>englishName</td>
                                          <td>
                                            englishName
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                                <tr>
                                  <td>name</td>
                                  <td>
                                    name
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>englishName</td>
                                  <td>
                                    englishName
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>busType</td>
                  <td>
                    busType
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>price</td>
                  <td>
                    price
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>discount</td>
                  <td>
                    discount
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>departureDate</td>
                  <td>
                    departureDate
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>issueDate</td>
                  <td>
                    issueDate
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>passengers</td>
                  <td>
                    passengers
                  </td>
                  <td>Collection of String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>firstName</td>
                          <td>firstName</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>lastName</td>
                          <td>lastName</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>seatNumber</td>
                          <td>seatNumber</td>
                          <td>Integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>nationalCode</td>
                          <td>nationalCode</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>gender</td>
                          <td>gender</td>
                          <td>Integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>
                    status
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>token</td>
                  <td>
                    token
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>ticketCode</td>
                  <td>
                    ticketCode
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(TicketResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default BusTicketPage;